<dl>
  <dt class="mb-3">
    <strong>
      Decyzje
    </strong>
  </dt>
  <dd>
    <app-location-decisions-preview
      [locationDecisions]="occupation?.locationDecisions || []"></app-location-decisions-preview>
  </dd>
</dl>
<br>
<dl>
  <dt class="mb-3">
    <strong>Etapy</strong>
  </dt>
  <dd>
    <ol>
      @for (stage of occupation?.stages; track $index) {
        <li>
          <div class='row'>
            <div class='col-md-4'>
              <app-label label='Data od:'>
                {{ stage?.startDate | date }}
              </app-label>
            </div>
            <div class='col-md-4'>
              <app-label label='Data do:'>
                {{ stage?.endDate | date }}
              </app-label>
            </div>
            <div class="col-md-4">
              <app-label label="Ilość dni:">
                {{ stage.dayQuantity }}
              </app-label>
            </div>
          </div>
          <div class="row">
            <div class='col-12'>
              <app-label label='Geometria:'>
                {{ stage?.geometry ? 'Tak' : 'Nie' }}
              </app-label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <app-label label="Nazwa drogi:">
                {{ stage.roadName || '-' }}
              </app-label>
            </div>
            <div class="col-md-4">
              <app-label label="Numer drogi:">
                {{ stage.roadNumber || '-' }}
              </app-label>
            </div>
            <div class="col-md-4">
              <app-label label="Ulica:">
                {{ stage.street || '-' }}
              </app-label>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-12">
              <p class="mb-2">
                <strong>
                  Działki
                </strong>
              </p>
              <app-parcels-preview [parcels]="stage.parcels">
              </app-parcels-preview>
              <br>
            </div>
          </div>
        </li>
        <div class="row">
          <div class="col-12">
            <table class='table table-silver'>
              <thead>
                <tr>
                  <th style='width: 20rem'></th>
                  <th>
                    Szerokość
                  </th>
                  <th>
                    Długość
                  </th>
                  <th>
                    Powierzchnia
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (fee of stage?.purposeFees; track $index) {
                  <tr>
                    <td class='align-left'>
                      <strong>
                        <small>
                          {{ fee.name }}
                        </small>
                      </strong>
                    </td>
                    <td>
                      {{ fee.width + '' | toNumber | number }} m
                    </td>
                    <td>
                      {{ fee.length + '' | toNumber | number }} m
                    </td>
                    <td>
                      {{ fee.area + '' | toNumber | number }} m<sup>2</sup>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
        @if (!$last) {
          <hr>
        }
      }
    </ol>
  </dd>
</dl>
